/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { MutationFunction, useMutation, UseMutationOptions } from 'react-query';

function makeCombinedCallback(defaultConfig: any, config: any, attr: string) {
  return (...data: any[]) => {
    defaultConfig && defaultConfig[attr] && defaultConfig[attr](...data);
    config && config[attr] && config[attr](...data);
  };
}

export default function mutationWrapper<V, T>(
  func: MutationFunction<V, T>,
  defaultConfig?: UseMutationOptions<V, unknown, T, unknown>
) {
  return function (config?: UseMutationOptions<V, unknown, T, unknown>) {
    return useMutation(func, {
      ...(defaultConfig || {}),
      ...config,
      onSuccess: makeCombinedCallback(defaultConfig, config, 'onSuccess'),
      onError: makeCombinedCallback(defaultConfig, config, 'onError')
    });
  };
}